import React, { useState } from 'react';
import { Copy, Check, Palette, Sparkles } from 'lucide-react';

export default function ColorPaletteExtractor({
  colors = ['#7B3FFF', '#3BF686', '#090910', '#1C1C2E', '#F4F4FF', '#4F8EFF'],
  title = "Extracted Color Palette"
}) {
  const [copiedColor, setCopiedColor] = useState(null);

  const handleCopy = (color) => {
    navigator.clipboard.writeText(color);
    setCopiedColor(color);
    setTimeout(() => {
      setCopiedColor(null);
    }, 2000);
  };

  return (
    <div style={{
      background: 'var(--bg-surface)',
      border: '1px solid var(--border-subtle)',
      borderRadius: '16px',
      padding: '20px',
      marginBottom: '24px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Palette size={16} color="var(--primary)" />
          <span style={{ fontSize: '0.875rem', fontWeight: 700, color: 'var(--text-primary)' }}>{title}</span>
        </div>
        <span style={{ fontSize: '0.75rem', color: 'var(--text-tertiary)', display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Sparkles size={12} color="var(--accent)" /> Click to copy HEX
        </span>
      </div>

      {/* Swatches Grid */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))', gap: '10px' }}>
        {colors.map((hex, idx) => {
          const isCopied = copiedColor === hex;
          return (
            <button
              key={idx}
              type="button"
              onClick={() => handleCopy(hex)}
              className="tactile-btn"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                padding: '6px',
                borderRadius: '12px',
                border: '1px solid var(--border-subtle)',
                background: 'var(--bg-base)',
                cursor: 'pointer',
                textAlign: 'left',
                position: 'relative'
              }}
            >
              {/* Color Box */}
              <div
                style={{
                  height: '42px',
                  borderRadius: '8px',
                  backgroundColor: hex,
                  border: '1px solid rgba(255,255,255,0.1)',
                  marginBottom: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.15)'
                }}
              >
                {isCopied && (
                  <div style={{
                    background: 'rgba(0,0,0,0.75)',
                    color: '#FFFFFF',
                    borderRadius: '50%',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Check size={14} color="var(--accent)" />
                  </div>
                )}
              </div>

              {/* Hex Label */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 2px'
              }}>
                <span style={{ fontSize: '0.75rem', fontWeight: 700, fontFamily: 'monospace', color: 'var(--text-primary)' }}>
                  {hex}
                </span>
                {isCopied ? (
                  <span style={{ fontSize: '0.625rem', color: 'var(--accent)', fontWeight: 700 }}>COPIED</span>
                ) : (
                  <Copy size={11} color="var(--text-tertiary)" />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
